import { Visibility, VisibilityOff } from '@mui/icons-material';
import {
  Button, CircularProgress, Container, FormHelperText, Grid, IconButton, TextField,
} from '@mui/material';
import { useFormik } from 'formik';
import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import Images from '../../../../Configs/images';
import ROUTES from '../../../../Configs/routes';
import { login } from '../../../../Redux/Models/auth';

const DisplayingErrorMessagesSchema = Yup.object().shape({
  email: Yup.string()
    .email('Please check your email address format')
    .required('Email field is required'),
  password: Yup.string()
    .required('Password field is required'),
});

export default function SignIn({
  classes,
  isLoading,
  error,
  message,
  loginSuccess,
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.pathname !== '/signin') {
      navigate(ROUTES.signin());
    }
  }, [location]);

  const [visible, setVisible] = useState(false);

  const formik = useFormik({
    initialValues: {
      email: '',
      password: '',
    },
    validationSchema: DisplayingErrorMessagesSchema,
    onSubmit: (values) => {
      dispatch(login(values));
    },
  });

  const toggleVisibility = () => {
    setVisible(!visible);
  };

  useEffect(() => {
    if (formik.touched && loginSuccess) {
      navigate(ROUTES.otp(), { state: formik.values });
    }
  }, [loginSuccess, formik.touched]);

  const errorAPI = error && formik.touched.password && !loginSuccess;

  return (
    <div className={classes.root}>
      <Grid container spacing={0} justifyContent="center">
        <Grid item xs={12} sm={10} md={6} lg={4}>
          <Container sx={{ py: 5, minHeight: '100vh', position: 'relative' }} maxWidth="sm">
            <div className="center">
              <h1>
                <img src={Images.Logo} alt="Boxpack" height={65} />
              </h1>
              <h3 className="mt-6 s-16">Sign in</h3>
              <div className="desc center mt-1 s-14">Welcome! Please enter your details</div>
            </div>
            <form onSubmit={formik.handleSubmit} className="mt-6">
              <div>
                <label htmlFor="email">
                  Email
                  <span className="primary-green">*</span>
                </label>
                <TextField
                  id="email"
                  size="small"
                  placeholder="youremail@address.com"
                  fullWidth
                  autoComplete="off"
                  InputProps={{
                    autoComplete: 'new-password',
                  }}
                  error={formik.touched.email && formik.errors.email}
                  name="email"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                />
                {(formik.touched.email && formik.errors.email)
                && (
                <FormHelperText error sx={{ fontSize: 14 }}>
                  {formik.errors.email}
                </FormHelperText>
                )}
              </div>

              <div className="mt-4">
                <label htmlFor="pass">
                  Password
                  <span className="primary-green">*</span>
                </label>
                <TextField
                  type={visible ? 'text' : 'password'}
                  size="small"
                  id="pass"
                  placeholder="Password"
                  fullWidth
                  InputProps={{
                    endAdornment: (
                      <IconButton sx={{ m: 0, p: 0 }} onClick={toggleVisibility}>
                        {visible
                          ? <Visibility />
                          : <VisibilityOff />}
                      </IconButton>
                    ),
                    autoComplete: 'new-password',
                  }}
                  error={formik.touched.password && formik.errors.password}
                  name="password"
                  value={formik.values.password}
                  onChange={formik.handleChange}
                />
                {(formik.touched.password && formik.errors.password)
                && (
                <FormHelperText error sx={{ fontSize: 14 }}>
                  {formik.errors.password}
                </FormHelperText>
                )}
                {errorAPI
                && <FormHelperText error sx={{ fontSize: 14 }}>{message}</FormHelperText>}
              </div>
              <div className="right mt-5">
                <Link to={ROUTES.forgotPassword()} className="link black weight-600 s-14">Forgot password?</Link>
              </div>

              <div className="mt-5">
                <Button disabled={isLoading} startIcon={isLoading && (<CircularProgress size={18} sx={{ mr: 1, color: '#fff' }} />)} size="large" type="submit" variant="contained" className="btn-contained" fullWidth>Sign in</Button>
              </div>

              <div className="center mt-5">
                <div className="s-14 weight-600">
                  Don&apos;t have account?
                  {' '}
                  <Link to={ROUTES.signup()} className="link primary-green weight-700">Sign up</Link>
                </div>
              </div>

              <div className="center mt-4">
                <Link to={ROUTES.market()} className="link s-14 black weight-600">
                  Take a look our
                  {' '}
                  <u className="weight-700">OenoMarket</u>
                </Link>
              </div>
            </form>
          </Container>
        </Grid>
      </Grid>
    </div>
  );
}
